/**
 * Client-side avatar prep (Beta-1 plan P4-27): center-crop to a square, resize to `size` px and
 * encode as WebP under `maxBytes` (quality steps down until it fits). Returns a Blob.
 */
export async function prepareAvatar(file, { size = 256, maxBytes = 200 * 1024 } = {}) {
  const bitmap = await loadImage(file);
  const side = Math.min(bitmap.width, bitmap.height);
  const sx = (bitmap.width - side) / 2;
  const sy = (bitmap.height - side) / 2;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(bitmap, sx, sy, side, side, 0, 0, size, size);
  for (const q of [0.9, 0.8, 0.7, 0.6, 0.5, 0.4]) {
    // eslint-disable-next-line no-await-in-loop
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/webp', q));
    if (blob && blob.size <= maxBytes) return blob;
  }
  const last = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.5));
  if (!last || last.size > maxBytes) throw new Error('Could not shrink the photo enough — try a smaller image.');
  return last;
}

function loadImage(file) {
  if (typeof createImageBitmap === 'function') return createImageBitmap(file);
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = reject;
    img.src = url;
  });
}
